import { useContext, useState } from 'react';
import ConsultImpvWrite from './ConsultImpvWrite';
import ConsultFlfmtWrite from './ConsultFlfmtWrite';
import ConsultTotalResult from './ConsultTotalResult';
import ConsultVideoResult from './ConsultVideoResult';
import ConsultVideoFrame from './ConsultVideoFrame';
import { GlobalContext, useGlobalStore } from '../../../components/contexts';

const ConsultDetailContent = ({ rslt, onChangeRslt, svcObj, modalService }) => {
  // 작업별 공통 tab menu 기능 구현
  const [currentTab, clickTab] = useState(0);
  const [isFrameDetailClicked, setIsFrameDetailClicked] = useState(false);
  let detailRef = rslt;
  const modalParam = { svcObj, detailRef };
  const store = useContext(GlobalContext);

  let tabMenuArr;
  if (
    store.store?.authrtId === 'EX' &&
    svcObj.cnsltSttsCd !== 'CNSLT03' &&
    svcObj.cnsltSttsCd !== 'CNSLT04'
  ) {
    tabMenuArr = [
      {
        name: '전문가 분석 결과',
        content: (
          <ConsultTotalResult
            rslt={rslt}
            onChangeRslt={onChangeRslt}
            param={{
              anlsAplyId: svcObj.aiaAplyId,
              entSn: svcObj.entSn,
              vdoId: rslt.vdoId,
              exprtOwas: rslt.exprtOwas,
              exprtRula: rslt.exprtRula,
              exprtReba: rslt.exprtReba,
            }}
            id={detailRef.exprtAnlsDtlId}
          />
        ),
      },
      {
        name: '컨설팅',
        content: (
          <ConsultImpvWrite
            rslt={rslt}
            onChangeRslt={onChangeRslt}
            svcObj={svcObj}
          />
        ),
      },
      {
        name: '수행사항',
        content: (
          <ConsultFlfmtWrite
            rslt={rslt}
            onChangeRslt={onChangeRslt}
            svcObj={svcObj}
          />
        ),
      },
    ];
  } else if (
    store.store?.authrtId === 'EX' &&
    (svcObj.cnsltSttsCd === 'CNSLT03' || svcObj.cnsltSttsCd === 'CNSLT04')
  ) {
    tabMenuArr = [
      {
        name: '전문가 분석 결과',
        content: (
          <ConsultTotalResult
            rslt={rslt}
            onChangeRslt={onChangeRslt}
            param={{
              anlsAplyId: svcObj.aiaAplyId,
              entSn: svcObj.entSn,
              vdoId: rslt.vdoId,
              exprtOwas: rslt.exprtOwas,
              exprtRula: rslt.exprtRula,
              exprtReba: rslt.exprtReba,
            }}
            id={detailRef.exprtAnlsDtlId}
          />
        ),
      },
      {
        name: '컨설팅',
        content: (
          <ConsultImpvWrite
            rslt={rslt}
            onChangeRslt={onChangeRslt}
            svcObj={svcObj}
          />
        ),
      },
      {
        name: '수행사항',
        content: (
          <ConsultFlfmtWrite
            rslt={rslt}
            onChangeRslt={onChangeRslt}
            svcObj={svcObj}
          />
        ),
      },
      {
        name: 'AI 영상검증 결과',
        content: isFrameDetailClicked ? (
          <ConsultVideoFrame
            param={{
              aiaRsltId: rslt.aiaRsltId,
              vdoId: rslt.vldVdoId,
            }}
          />
        ) : (
          <ConsultVideoResult
            param={{
              anlsAplyId: rslt.vldAplyId,
              entSn: svcObj.entSn,
              vdoId: rslt.vldVdoId,
            }}
          />
        ),
      },
    ];
  } else if (
    svcObj.cnsltSttsCd === 'CNSLT01' ||
    svcObj.cnsltSttsCd === 'EXPRT05'
  ) {
    tabMenuArr = [
      {
        name: '전문가 분석 결과',
        content: (
          <ConsultTotalResult
            rslt={rslt}
            onChangeRslt={onChangeRslt}
            param={{
              anlsAplyId: svcObj.aiaAplyId,
              entSn: svcObj.entSn,
              vdoId: rslt.vdoId,
              exprtOwas: rslt.exprtOwas,
              exprtRula: rslt.exprtRula,
              exprtReba: rslt.exprtReba,
            }}
            id={detailRef.exprtAnlsDtlId}
          />
        ),
      },
    ];
  } else if (
    (store.store?.authrtId === 'ME' || store.store?.authrtId === 'MU') &&
    (svcObj.cnsltSttsCd === 'CNSLT02' ||
      svcObj.cnsltSttsCd === 'CNSLT03' ||
      svcObj.cnsltSttsCd === 'CNSLT04')
  ) {
    tabMenuArr = [
      {
        name: '전문가 분석 결과',
        content: (
          <ConsultTotalResult
            rslt={rslt}
            onChangeRslt={onChangeRslt}
            param={{
              anlsAplyId: svcObj.aiaAplyId,
              entSn: svcObj.entSn,
              vdoId: rslt.vdoId,
              exprtOwas: rslt.exprtOwas,
              exprtRula: rslt.exprtRula,
              exprtReba: rslt.exprtReba,
            }}
            id={detailRef.exprtAnlsDtlId}
          />
        ),
      },
      {
        name: '수행사항',
        content: (
          <ConsultFlfmtWrite
            rslt={rslt}
            onChangeRslt={onChangeRslt}
            svcObj={svcObj}
          />
        ),
      },
      {
        name: 'AI 영상검증 결과',
        content: isFrameDetailClicked ? (
          <ConsultVideoFrame
            param={{
              aiaRsltId: rslt.aiaRsltId,
              vdoId: rslt.vldVdoId,
            }}
          />
        ) : (
          <ConsultVideoResult
            param={{
              anlsAplyId: rslt.vldAplyId,
              entSn: svcObj.entSn,
              vdoId: rslt.vldVdoId,
            }}
          />
        ),
      },
    ];
  } else {
    tabMenuArr = [
      {
        name: '전문가 분석 결과',
        content: (
          <ConsultTotalResult
            rslt={rslt}
            onChangeRslt={onChangeRslt}
            param={{
              anlsAplyId: svcObj.aiaAplyId,
              entSn: svcObj.entSn,
              vdoId: rslt.vdoId,
              exprtOwas: rslt.exprtOwas,
              exprtRula: rslt.exprtRula,
              exprtReba: rslt.exprtReba,
            }}
            id={detailRef.exprtAnlsDtlId}
          />
        ),
      },
      {
        name: '수행사항',
        content: (
          <ConsultFlfmtWrite
            rslt={rslt}
            onChangeRslt={onChangeRslt}
            svcObj={svcObj}
          />
        ),
      },
    ];
  }

  const selectTabMenuHandler = index => {
    clickTab(index);
  };

  return (
    <>
      <div className="section">
        <div className="tabs-wrap">
          <ul className="nav-tabs">
            {tabMenuArr.map((el, index) => (
              <li
                key={index}
                className={index === currentTab ? 'tabs on' : 'tabs'}
                onClick={() => selectTabMenuHandler(index)}
              >
                <a>{el.name}</a>
              </li>
            ))}
          </ul>
        </div>
        <div className="result-box-wrap">{tabMenuArr[currentTab].content}</div>

        {currentTab !== 0 ? null : (
          <div className="btn-group2">
            <button
              type="button"
              className="btn btn--sml"
              onClick={() => {
                // 추가자료 요청 Modal
                modalService.openModal(
                  'AnalyzeAddModal',
                  modalParam,
                  (index, isCompleted) => {
                    // Callback
                    onChangeRslt(index, 'Y', isCompleted);
                  }
                );
              }}
            >
              추가자료 확인
            </button>
          </div>
        )}

        {tabMenuArr[currentTab].name == 'AI 영상검증 결과' ? (
          <div className="btn-group2">
            <button
              type="button"
              className="btn btn--sml"
              onClick={() => {
                setIsFrameDetailClicked(!isFrameDetailClicked);
              }}
            >
              {isFrameDetailClicked ? '검증 전체결과' : '프레임별상세'} {}
            </button>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default ConsultDetailContent;
